if (!customElements.get('cinoton-product-navigation')) {
  class CinotonProductNavigation extends HTMLElement {
    connectedCallback() {
      this.nav = this.querySelector('[data-cinoton-content-nav]');
      this.links = Array.from(this.querySelectorAll('a[href^="#"]'));
      if (!this.nav || !this.links.length) return;

      this.handleViewportChange = this.requestUpdate.bind(this);
      this.links.forEach((link) => link.addEventListener('click', (event) => {
        const target = this.targetFor(link);
        if (!target) return;
        if (`#${target.id}` !== link.getAttribute('href')) {
          event.preventDefault();
          target.scrollIntoView({ block: 'start' });
        }
        this.setActive(link);
      }));
      window.addEventListener('scroll', this.handleViewportChange, { passive: true });
      window.addEventListener('resize', this.handleViewportChange, { passive: true });
      this.domObserver = new MutationObserver(this.handleViewportChange);
      this.domObserver.observe(document.body, { childList: true, subtree: true });
      this.requestUpdate();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleViewportChange);
      window.removeEventListener('resize', this.handleViewportChange);
      this.domObserver?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
    }

    targetFor(link) {
      const primary = document.querySelector(link.getAttribute('href'));
      const fallbackSelector = link.dataset.cinotonNavFallback;
      const fallback = fallbackSelector ? document.querySelector(fallbackSelector) : null;
      return [primary, fallback].find((target) => target && target.getClientRects().length) || null;
    }

    requestUpdate() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = 0;
        this.updateActiveLink();
      });
    }

    updateActiveLink() {
      const offset = parseFloat(getComputedStyle(document.body).getPropertyValue('--cinoton-product-nav-offset')) || 0;
      const activationLine = window.scrollY + offset + this.nav.getBoundingClientRect().height + 2;
      const targets = this.links
        .map((link) => {
          const target = this.targetFor(link);
          link.hidden = !target;
          return { link, target };
        })
        .filter((item) => item.target)
        .map((item) => ({ ...item, top: item.target.getBoundingClientRect().top + window.scrollY }))
        .sort((first, second) => first.top - second.top);

      let active = targets[0]?.link;
      targets.forEach((item) => {
        if (item.top <= activationLine) active = item.link;
      });
      const atDocumentEnd = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2;
      if (atDocumentEnd && targets.length) active = targets[targets.length - 1].link;
      this.setActive(active);
    }

    setActive(activeLink) {
      if (!activeLink || activeLink.classList.contains('active')) return;
      this.links.forEach((link) => {
        const selected = link === activeLink;
        link.classList.toggle('active', selected);
        if (selected) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });

      const rail = activeLink.parentElement;
      if (rail && rail.scrollWidth > rail.clientWidth) {
        rail.scrollTo({ left: activeLink.offsetLeft - (rail.clientWidth - activeLink.offsetWidth) / 2 });
      }
    }
  }

  customElements.define('cinoton-product-navigation', CinotonProductNavigation);
}
